import MuiAvatar from '@mui/material/Avatar'

export const Avatar = (props) => {
  return <MuiAvatar sx={{ width: 56, height: 56 }} {...props} />
}

export default Avatar
